/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDiscountResponse } from '../../models/page-discount-response';

export interface GetDiscountsList$Params {

/**
 * Discount type to filter by
 */
  discountType: 'VIP' | 'SGM' | 'QNT' | 'BSK';

/**
 * Packaging unit IDs to filter by (could be null or empty)
 */
  packagingUnitIdIn?: Array<string>;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getDiscountsList(http: HttpClient, rootUrl: string, params: GetDiscountsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDiscountResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscountsList.PATH, 'get');
  if (params) {
    rb.query('discountType', params.discountType, {});
    rb.query('packagingUnitIdIn', params.packagingUnitIdIn, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDiscountResponse>;
    })
  );
}

getDiscountsList.PATH = '/discounts';
